<template>
    <div>
        <div class="edit-content img-content">
            <div class="abstract edit-text">
                <input type="text" class="title-textarea" rows="1" maxlength="50" placeholder="请输入简介（50个字以内）"
                    v-model="params.summary" @blur="editStatus.summary = true">
                <span class="wordsNum"><em class="wordsNum-dynamic">{{params.summary.length | 0}}</em>/<em
                        class="wordsNum-fixed">50</em></span>
                <!-- 错误提示 -->
                <p class="error-prompt" v-show="editStatus.summary && !params.summary.length">未输入简介</p>
            </div>
            <div class="edit-lable edit-text js-edit-lable" @click="showTagDialog">
                <p class="placeholder" v-show="!tagDialog.selectedTags.length">请添加标签</p>
                <div class="edit-lable-box">
                    <p class="edit-lable-con" v-for="(sTag,index) in tagDialog.selectedTags" :key="index">
                        <span class="edit-lable-text f-hide-col-1">{{ sTag.tagName }}</span>
                        <span class="ico ico-label-close" @click.stop.prevent="delTag(sTag)"></span>
                    </p>
                </div>
                <span class="wordsNum">2～9个标签</span>
                <!-- 错误提示 -->
                <p class="error-prompt" v-show="editStatus.tag && !tagDialog.selectedTags.length">未添加标签</p>
            </div>

            <tag-dialog ref="tagDialog" :curGameId="curGameId" :visible.sync="tagDialog.visible"
                @cancelSubmit="cancelChangeTags" :selectedTags.sync="tagDialog.selectedTags" :tags.sync="params.tags">
            </tag-dialog>

            <div class="edit-text key-word js-key-word" ref="keywordBox">
                <div class="title-textarea" @click="dropKeywordBox">
                    <p class="placeholder" v-show="keywordBox.selected.length === 0">请选择关键词(2～9个)</p>
                    <div class="title-textarea-label">
                        <p class="edit-lable-con" v-for="(sKeyword,index) in  keywordBox.selected" :key="index">
                            <span class="edit-lable-text">{{ sKeyword.keywordName.substr(0,10)}}</span>
                            <span class="ico ico-label-close" @click="chooseKeyword(sKeyword)"></span>
                        </p>
                    </div>
                </div>
                <i class="ico-writing select-btn" :class="keywordBox.show ? 'ico-drap-up' : 'ico-drap-down'"
                    @click="dropKeywordBox"></i>
                <!-- 错误提示 -->
                <p class="error-prompt" v-if="editStatus.keywords && !keywordBox.selected.length">未添加关键词</p>
                <div class="g-selector-option classify-selector" v-if="keywordBox.show">
                    <div class="selector g-scrollbar">
                        <div class="key-word-search">
                            <input class="key-word-con g-input" type="text" v-model="keywordBox.selectWord"
                                placeholder="请输入要搜索的内容">
                            <span class="ico ico-search"></span>
                        </div>
                        <div class="select-item" v-for="(keyword,index) in getSearchKeywordList" @click="chooseKeyword(keyword)"
                            :key="index">
                            <label class="ico ico-check js-check f-inlineblock-middle" :class="{'ico-check-active':keyword.selected}">
                                <!--<input class="select-checkbox" type="checkbox" name=""-->
                                <!--v-model="keyword.id"-->
                                <!--&gt;-->
                            </label>
                            <p class="select-item-con f-inlineblock-top">{{ keyword.keywordName }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="edit-text author-name">
                <input type="text" class="title-textarea" rows="1" maxlength="10" placeholder="请输入作者昵称（10个字以内）"
                    v-model="params.author">
                <!-- 错误提示 -->
                <p class="error-prompt" v-show="editStatus.author && !params.author.length">未输入作者</p>
            </div>
            <div class="select-type">
                <div class="edit-theme-type f-inlineblock-top">
                    <select-box :selectList="pageConf.themeList" itemTitle="题材类型" :selected.sync="params.theme_id"
                        @change="editStatus.theme_id = true"></select-box>
                </div>
                <div class="edit-theme-type f-inlineblock-top" v-if="curGameId == 362">
                    <select-box :selectList="pageConf.kolList" itemTitle="KOL相关" :selected.sync="params.kol"></select-box>
                </div>
                <!-- 错误提示 -->
                <p class="error-prompt" v-if="editStatus.theme_id && !params.theme_id">未选择题材</p>
            </div>

            <div class="upload-cover">
                <div class="img-upload f-inlineblock-top" v-for="(item,index) in coverList" :key="index">
                    <tgl-image-cloud-upload :extra="'normal'+(index == 0 ? '' : index)" :maxSize="6*1024*1024"
                        :editBtn="true" style="display: inline-block" :btnId="'commonPic'+index" :ref="'commonPic'+index"
                        :isCrop="true" :domWidth="207" @completed="imageUploadCompletedMore">
                        <template #text>
                            <div style='font-size: 12px'>
                                上传通用封面图
                                <br>
                                最大6M，支持jpg/png格式
                            </div>
                        </template>
                    </tgl-image-cloud-upload>
                </div>
                <div class="img-upload f-inlineblock-top" v-show="coverList.length < 5" @click="editStatus.commonPic = true">
                    <tgl-image-cloud-upload :extra="'normal' + (coverListIds.length == 0 ? '' : coverListIds.length.toString())"
                        :maxSize="6*1024*1024" v-if="normalShow" style="display: inline-block" btnId='commonPic'
                        ref="commonPic" :isCrop="true" :domWidth="207" @completed="imageUploadCompleted">
                        <template #text>
                            <div style='font-size: 12px'>上传通用封面图（最多5张）
                                <br>最大6M，支持jpg/png格式
                            </div>
                        </template>
                    </tgl-image-cloud-upload>
                </div>
                <!-- 错误提示 -->
                <div class="error-prompt">
                    <p class="error-prompt-con" v-if="!coverListIds.length">通用封面未上传</p>
                    <!-- <p class="error-prompt-con" v-if="editStatus.qqCover && !editResult.qqCover">手Q封面未上传</p> -->
                    <!-- <p class="error-prompt-com" v-if="editStatus.qqRecommendPic && !editResult.qqRecommendPic">手Q推荐未上传</p> -->
                </div>
            </div>
        </div>
    </div>

</template>
<style  lang="scss" scoped>
@import '~Assets/sass/pages/v4/order/contribution.scss';
@import '~Assets/sass/pages/v4/order/order_contribute.scss';
</style>
<script>

import tagDialog from '../tag_dialog';
import selectBox from 'Components/v4/dropdown/select_box';
import imgUpload from 'Components/v4/upload/imgUpload_v4';
import {
    mapGetters
} from 'vuex';
import store from 'Stores'
import {
    GameTags, GameKeywords
} from 'Services/getData.js';

export default {
    name: 'basic_form.vue', /*图文小说漫画视频共有字段*/
    props: {
        curGameId: {
            type: Number,
            default: 0
        },
        defaultParams: {
            type: Object
        }
    },
    data() {
        return {
            params: {
                theme_id: '', // 1：教学；2：赛事；3： 同人；4：娱乐；5：资讯
                kol: '', // 只有王者需要，是什么鬼？
                author: '', // 作者昵称
                content: '', // 内容详情
                summary: '', // 摘要
                covers: [], // 封面附件id集合
                tags: '', // 内容标签，
                keywords: '' // 内容关键词，
            },
            dialog: {
                showTag: false
            },
            tagDialog: {
                visible: true,
                selectedTags: [],
                prevSelectedTags: []
            },
            gameKeywordList: [],
            gameTagsList: [],
            keywordBox: {
                show: false,
                selectWord: '',
                selected: []
            },
            pageConf: {
                themeList: [
                    {
                        id: 1, name: '教学'
                    },
                    {
                        id: 2, name: '赛事'
                    },
                    // {id: 3, name :'同人'},
                    {
                        id: 4, name: '娱乐'
                    },
                    {
                        id: 5, name: '资讯'
                    }
                ],
                kolList: [
                    {
                        'id': '10127727', 'name': '零度'
                    },
                    {
                        'id': '784271615', 'name': '李九'
                    },
                    {
                        'id': '398753883', 'name': '瓶子'
                    },
                    {
                        'id': '505304294', 'name': '美人鱼头'
                    },
                    {
                        'id': '406867054', 'name': '琪琪'
                    },
                    {
                        'id': '278274932', 'name': '月爱'
                    },
                    {
                        'id': '2356328847', 'name': '梦泪'
                    },
                    {
                        'id': '826848632', 'name': '老帅'
                    },
                    {
                        'id': '410769672', 'name': '猫神'
                    },
                    {
                        'id': '466730886', 'name': '辰鬼'
                    },
                    {
                        'id': '2585907214', 'name': '小渝'
                    },
                    {
                        'id': '188915224', 'name': '飞牛'
                    },
                    {
                        'id': '604947164', 'name': '梦飞'
                    },
                    {
                        'id': '151497139', 'name': '小东'
                    },
                    {
                        'id': '123594343', 'name': '小棉花'
                    },
                    {
                        'id': '162452509', 'name': '呆阿拿'
                    }
                ]
            },
            editStatus: {
                summary: false,
                tag: false,
                keywords: false,
                author: false,
                theme_id: false,
                kol: false,
                commonPic: false,
                qqCover: false,
                qqRecommendPic: false
            },
            editResult: {
                commonPic: false,
                qqCover: false,
                qqRecommendPic: false
            },
            coverIds: [],
            vidInfo: null,
            commonPicInfo: {},
            qqRecommendPicInfo: {},
            qqCoverInfo: {},
            coverList: [],
            coverListIds: [],
            normalShow: true
        }
    },
    components: {
        tagDialog, selectBox, imgUpload
    },
    created() {
    },
    mounted() {
        document.addEventListener('click', (e) => {
            if (this.$refs.keywordBox) {
                if (!this.$refs.keywordBox.contains(e.target))
                    this.keywordBox.show = false;
            }
        })
    },
    filters: {},
    methods: {
        resetParam() {
            this.params = {
                theme_id: '', // 1：教学；2：赛事；3： 同人；4：娱乐；5：资讯
                kol: '', // 只有王者需要，是什么鬼？
                author: '', // 作者昵称
                // content: '',// 内容详情
                summary: '', // 摘要
                covers: ['', '', ''], // 封面附件id集合
                tags: '', // 内容标签，
                keywords: '' // 内容关键词，
            };
            this.qqRecommendPicInfo = {};
            this.commonPicInfo = {};
            this.qqCoverInfo = {};
            this.tagDialog.selectedTags = [];
            this.keywordBox.selected = [];
            if (this.$refs.qqCover) {
                this.$refs.qqCover.deletePic();
            }
            if (this.coverList.length) {
                this.coverList.forEach((v, index) => {
                    if (this.$refs[`commonPic${index}`]) {
                        (this.$refs[`commonPic${index}`])[0].deletePic();
                    }
                })
            }
            if (this.$refs.qqRecommendPic) {
                this.$refs.qqRecommendPic.deletePic();
            }
            store.commit('setMediaDistributeInfo', '');
            this.getKeywords();
        },
        showTagDialog() {
            this.tagDialog.prevSelectedTags = [];
            let {
                selectedTags
            } = this.tagDialog;
            if (selectedTags.length) {
                selectedTags.filter((obj) => {
                    this.tagDialog.prevSelectedTags.push(obj);
                })
            }
            this.editStatus.tag = true;
            this.$refs.tagDialog.showDialog();
        },
        dropKeywordBox() {
            this.editStatus.keywords = true;
            this.keywordBox.show = !this.keywordBox.show;
            this.keywordBox.selectWord = '';
        },
        cancelChangeTags() {
            this.tagDialog.selectedTags = this.tagDialog.prevSelectedTags;
            let tagId = this.tagDialog.selectedTags.map((tag) => {
                return tag.id
            });
            this.params.tags = tagId.join(',');
        },
        delTag(item) {
            this.editStatus.tag = true;
            if (this.$refs.tagDialog) {
                this.$refs.tagDialog.removeSelectItem(item);
            } else {
                let index = -1;
                for (let i = 0; i < this.tagDialog.selectedTags.length; i++) {
                    if (this.tagDialog.selectedTags[i].id == item.id) {
                        index = i;
                        break;
                    }
                }
                if (index !== -1) {
                    this.params.tags.splice(index, 1);
                }
            }
            let tags = this.tagDialog.selectedTags.map((tag) => {
                return tag.id
            });
            this.params.tags = tags.join(',');
        },
        chooseKeyword(keyword) {
            this.editStatus.keywords = true;
            keyword.selected = !keyword.selected;
            if (keyword.selected) {   // 添加
                this.keywordBox.selected.push(keyword);
            } else {
                for (let key in this.keywordBox.selected) { // 删除操作
                    if (this.keywordBox.selected[key].id == keyword.id) {
                        this.keywordBox.selected.splice(key, 1)
                    }
                }
            }
            let keywordIds = this.keywordBox.selected.map((keyword) => {
                return keyword.id
            });
            this.params.keywords = keywordIds.join(',');
        },
        imageUploadCompletedMore(res) {
            const eleId = res.btnId;
            let index = eleId.slice(-1);
            this.coverList[index] = res.url;
            this.coverListIds[index] = res.id;
            this.params.covers[index] = res.id;
            this.coverIds = res.id;
            if (eleId = 'commonPic0') {
                store.commit('setMediaDistributeInfo', res.url);
            }
        },
        imageUploadCompleted(res) {
            const eleId = res.btnId;
            if (eleId == 'commonPic') { // 删除注意
                this.coverList.push(res.url);
                this.coverListIds.push(res.id);
                this.params.covers[this.coverList.length - 1] = res.id;
                this.editResult.commonPic = this.params.covers[this.coverList.length - 1] ? true : false;
                this.coverIds = res.id;
                if (this.coverList.length == 1) {
                    store.commit('setMediaDistributeInfo', res.url);
                }

                this.$refs.commonPic.deletePic();
                this.normalShow = false;
                this.$nextTick(() => {
                    this.$refs[`commonPic${(this.coverList.length - 1).toString()}`][0].setPic(res.url);
                    setTimeout(() => {
                        this.normalShow = true;
                    }, 0);
                })
            } else if (eleId == 'qqCover') {
                this.params.covers[5] = res.id;
                this.coverIds = res.id;
                this.editResult.qqCover = this.params.covers[5] ? true : false;
            } else if (eleId == 'qqRecommendPic') {
                this.params.covers[6] = res.id;
                this.coverIds = res.id;
                this.editResult.qqRecommendPic = this.params.covers[6] ? true : false;
            }
        },
        async getKeywords(selectedKeywordIds = [], gameId = this.curGameId) {
            let res = await GameKeywords({
                gameId
            });
            if (res.data && res.data.data.length) {
                let data = res.data.data;
                this.gameKeywordList = data.map((k) => {
                    if (selectedKeywordIds.length) {
                        if (selectedKeywordIds.includes(k.id)) {
                            k.selected = true;
                        } else {
                            k.selected = false;
                        }
                    } else {
                        k.selected = false;
                    }
                    return k;
                })
            }
        },
        retSetKeyword(keywords, gameId) {
            let selectedKId = [];
            if (keywords.length) {
                keywords.filter((keyword) => {
                    keyword.selected = true;
                    selectedKId.push(parseInt(keyword.id));
                });
                this.keywordBox.selected = keywords;
                this.params.keywords = selectedKId.join(',');
            }
            this.getKeywords(selectedKId, gameId);
        },
        resetCovers(covers) {
            if (covers) {
                covers.filter((cover) => {
                    if (cover.extra == 'qq') {
                        this.qqCoverInfo = {
                            name: cover.attachmentName, cover: cover.attachmentUrl
                        };
                    } else if (cover.extra == 'qq_recommend') {
                        this.qqRecommendPicInfo = {
                            name: cover.attachmentName, cover: cover.attachmentUrl
                        };
                    } else {
                        this.commonPicInfo = {
                            name: cover.attachmentName, cover: cover.attachmentUrl
                        };
                        this.coverList.push(cover.attachmentUrl)
                        this.coverListIds.push(cover.id)
                        this.setCommonPic(this.coverList.length - 1, cover.attachmentUrl);
                        // this.$nextTick(()=>{
                        // this.$refs['commonPic'+(this.coverList.length-1).toString()][0].setPic(cover.attachmentUrl);
                        // })
                        this.normalShow = false;
                        this.$nextTick(() => {
                            this.normalShow = true;
                        })
                    }
                    this.params.covers.push(cover.id);
                });

            }
        },
        setCommonPic(index, url) {
            this.$nextTick(() => {
                this.$refs[`commonPic${index.toString()}`][0].setPic(url);
            })
        }
    },
    watch: {
        params: {
            handler(curVal, oldVal) {
                this.$emit('update:summary', this.params.summary);
                this.$emit('update:tags', this.params.tags);
                this.$emit('update:theme_id', this.params.theme_id);
                this.$emit('update:kol', this.params.kol);
                this.$emit('update:covers', this.params.covers);
                this.$emit('update:author', this.params.author);
                this.$emit('update:keywords', this.params.keywords);
            },
            deep: true
        },
        coverIds: {
            handler(curVal, oldVal) {
                this.$emit('update:covers', this.params.covers);
            },
            deep: true
        },
        curGameId: {
            handler(curVal, oldVal) {
                if (this.gameKeywordList.length == 0) {
                    this.getKeywords([]);
                }
            },
            deep: true
        },
        defaultParams: { // 更新页面数组
            handler(curVal, oldVal) {
                let {
                    theme_id, kol, author, summary, covers, tags, keywords, gameId
                } = curVal;
                this.tagDialog.selectedTags = [];
                if (tags.length) {
                    this.tagDialog.selectedTags = tags;
                }
                this.params.theme_id = theme_id;
                if (gameId == 362) {
                    this.params.kol = kol;
                }
                this.params.author = author;
                this.params.summary = summary;
                this.retSetKeyword(keywords, gameId);
                this.resetCovers(covers);
            },
            deep: true
        }

    },
    computed: {
        getSearchKeywordList() {
            let selectWord = this.keywordBox.selectWord;
            if (this.keywordBox.selectWord) {
                return this.gameKeywordList.filter((keyword) => {
                    if (keyword.keywordName.includes(selectWord)) {
                        return keyword;
                    }
                })
            } else {
                return this.gameKeywordList;
            }

        }
    }
}
</script>
